import moment from "moment";
import { useEffect, useState } from "react";
import {
  englishDate,
  ScrollToTop,
  setCurrentPageandResetData,
} from "../../algorithms";
import {
  customStyle,
  styleEnd,
  styleStart,
} from "../../algorithms/styleDirection";
import { resolver } from "../../API/middlewares/resolveRequests";
import { paths } from "../../paths/paths";
import Paginate from "../layout/paginate";
import Titlebar from "../layout/titlebar";
import Lang from "../../userPreferences/staticWords";
import { Link } from "react-router-dom";
import DateInput from "../sharedComponents/datesInputs/date";
import TextInput from "../sharedComponents/inputs/textInput";
import { searchAllFiles } from "./../../API/store/actions/files/files";
import Slide from "react-reveal/Slide";
import { useSelector } from "react-redux";
import LoadingPopup from "../layout/loadingPopup";

const Files = ({ userToken }) => {
  const [files, setFiles] = useState({});
  const [currentPage, setCurrentPage] = useState(1);
  const [searchText, setSearchText] = useState("");
  const [StartDate, setStartDate] = useState("");
  const [EndDate, setEndDate] = useState("");
  const [startDateError, setStartDateError] = useState(false);
  const [endDateError, setEndDateError] = useState(false);
  const communityId = useSelector((state) => state.community.communityId?.id);

  useEffect(() => {
    // resolver(getAllAttachments, setFiles, currentPage, 20, userToken);
    resolver(
      searchAllFiles,
      setFiles,
      currentPage,
      20,
      communityId,
      {
        name: searchText ? searchText : null,
        startDate: StartDate ? englishDate(StartDate) : null,
        endDate: EndDate ? englishDate(EndDate) : null,
      },
      userToken,
    );
    ScrollToTop();
  }, [currentPage, searchText, StartDate, EndDate]);
  const [showSearch, setShowSearch] = useState(false);

  if (files?.data)
    return (
      <>
        <Titlebar
          title={Lang.filesNavTab}
          customImage={"/assets/images/icons/fi-br-folder.png"}
        />

        <div
          className={`d-lg-none col-12 d-flex justify-content-center align-items-center mt-4`}
          style={{ zIndex: 10 }}
          title={"بحث"}
        >
          <div
            className={`mx-2 d-flex justify-content-center align-items-center ${
              showSearch == true ? "backgroundEffect" : "bg-white"
            }`}
            style={{
              border: "1px solid rgba(199, 199, 201, 1)",
              borderRadius: "50%",
              height: 40,
              width: 40,
              cursor: "pointer",
            }}
            onClick={() => {
              setShowSearch(!showSearch);
            }}
          >
            <img
              className={`${showSearch == true ? "filterEffect" : ""}`}
              src="/assets/images/filter.svg"
              width={20}
              height={20}
              alt=""
            />
          </div>
        </div>

        <div
          className={`d-lg-flex d-none col justify-content-end my-2 my-md-0 ${customStyle(
            "filterIconFiles",
          )}`}
          style={{ zIndex: 10 }}
          title={"بحث"}
        >
          <div
            className={`mx-2 d-flex justify-content-center align-items-center ${
              showSearch == true ? "backgroundEffect" : "bg-white"
            }`}
            style={{
              border: "1px solid rgba(199, 199, 201, 1)",
              borderRadius: "50%",
              height: 40,
              width: 40,
              cursor: "pointer",
              zIndex: 10,
            }}
            onClick={() => {
              setShowSearch(!showSearch);
            }}
          >
            <img
              className={`${showSearch == true ? "filterEffect" : ""}`}
              src="/assets/images/filter.svg"
              width={20}
              height={20}
              alt=""
            />
          </div>
        </div>

        {/* search Input Start */}
        {showSearch && (
          <Slide left opposite collapse when={showSearch}>
            <div
              className={`d-flex flex-column ${styleStart(
                "p",
                4,
                "md",
              )} justify-content-center justify-content-lg-start align-items-center align-items-lg-start mt-4 align-items-center`}
            >
              <div className="d-flex flex-lg-row flex-column col-lg-8 col-11">
                <TextInput
                  value={searchText}
                  iconName={"search"}
                  iconSize={16}
                  style={{ padding: "21px" }}
                  iconPrefix={"fas"}
                  hiddenPlaceholder={"اسم الملف"}
                  type={"text"}
                  containerStyle={"col-lg-6 col-12 mb-3 ms-3"}
                  onChange={(e) => {
                    setSearchText(e.target.value);
                    setCurrentPage(1);
                  }}
                />

                <div className="d-flex col-12 col-lg-6 flex-lg-row flex-column align-items-center align-items-lg-start mt-0 px-0">
                  <div
                    className={`col-12 mb-3 mb-lg-0 col-lg-6 ${styleEnd(
                      "p",
                      3,
                      "lg",
                    )}`}
                  >
                    <div className="col-12 align-items-center align-items-xl-start">
                      <DateInput
                        errorMessage={
                          startDateError === true ? Lang.invalidDate : null
                        }
                        style={{ padding: "21px" }}
                        placeholder={Lang.from}
                        containerStyle={"col-12"}
                        name={"StartDate"}
                        value={StartDate}
                        onChange={(e) => {
                          if (e) {
                            setStartDate(e);
                            if (!EndDate || (EndDate && e <= EndDate)) {
                              setStartDateError(false);
                              setEndDateError(false);
                            } else {
                              setStartDateError(true);
                            }
                          }
                        }}
                        onIconClick={() => {
                          if (StartDate != "") {
                            setStartDate("");
                            setStartDateError(false);
                          }
                        }}
                        iconPrefix={StartDate == "" ? "far" : "fas"}
                        iconName={StartDate == "" ? "calendar" : "times"}
                        iconSize={22}
                      />
                    </div>
                    {/* {startDateError === true ? (
                    <div>
                      <p className="my-2 text-danger">{Lang.invalidDate}</p>
                    </div>
                  ) : null} */}
                  </div>

                  <div className={`col-12 mb-3 mb-lg-0 col-lg-6 `}>
                    <div className="col-12 align-items-center">
                      <DateInput
                        errorMessage={
                          endDateError === true ? Lang.invalidDate : null
                        }
                        placeholder={Lang.to}
                        containerStyle={"col-12"}
                        style={{ padding: "21px" }}
                        value={EndDate}
                        onChange={(e) => {
                          if (e) {
                            setEndDate(e);
                            if (!StartDate || (StartDate && e >= StartDate)) {
                              setEndDateError(false);
                              setStartDateError(false);
                            } else {
                              setEndDateError(true);
                            }
                          }
                        }}
                        onIconClick={() => {
                          if (EndDate != "") {
                            setEndDate("");
                            setEndDateError(false);
                          }
                        }}
                        iconPrefix={EndDate == "" ? "far" : "fas"}
                        iconName={EndDate == "" ? "calendar" : "times"}
                        iconSize={22}
                      />
                    </div>
                    {/* {endDateError === true ? (
                    <div>
                      <p className="my-2 text-danger">{Lang.invalidDate}</p>
                    </div>
                  ) : null} */}
                  </div>
                </div>
              </div>
            </div>
          </Slide>
        )}
        {searchText ? (
          <div
            className={`d-flex ${styleStart(
              "p",
              5,
              "md",
            )} justify-content-center justify-content-lg-start mt-3 align-items-center `}
          >
            <span className=" fw-bold">نتائج البحث عن</span>: {searchText}{" "}
          </div>
        ) : null}
        {/* search Input End */}

        <div className="d-flex flex-lg-row flex-column-reverse flex-wrap align-items-center">
          <div
            className={`d-flex flex-column align-self-center col-lg-8 col-10 ${styleStart(
              "m",
              4,
              "lg",
            )} mx-0`}
          >
            {files.data.map((item, index) => {
              return (
                <div key={index + parseInt(item.id)} className="col-12 mt-4">
                  <div className="d-flex">
                    <hr
                      className="col mx-4"
                      style={{ height: 2, color: "#656565" }}
                    />
                    {/* date of attachments here */}
                    <div>
                      <p className="my-0">{`${moment(new Date(item.createDate))
                        .format("LLLL")
                        .split(" ")
                        .splice(0, 4)
                        .join(" ")}`}</p>
                    </div>
                    <hr
                      className="col mx-4"
                      style={{ height: 2, color: "#656565" }}
                    />
                  </div>

                  {/* map attachments here */}
                  {item.attachments.map((attachment, index) => {
                    let img;
                    if (attachment.type == "Task")
                      img = `url("/assets/images/icons/fi-br-layers.png") 0% 0% no-repeat padding-box`;
                    else
                      img = `url("/assets/images/icons/projection-screen.png") 0% 0% no-repeat padding-box`;
                    return (
                      <div
                        key={index}
                        className="my-4"
                        style={{
                          border: "1px solid #DFDFE2",
                          borderRadius: 4,
                        }}
                      >
                        <div
                          key={index + parseInt(attachment.id)}
                          className="d-flex"
                        >
                          <div className="d-flex justify-content-start col-10 align-items-center py-3">
                            <a
                              href={`${
                                attachment.type == "Task"
                                  ? paths.TasksAttachments
                                  : paths.ProjectsAttachments
                              }${attachment.id}/${attachment.attachmentId}/${
                                attachment.attachment
                              }`}
                              className={`d-flex text-decoration-none ${styleStart(
                                "m",
                                2,
                              )}`}
                              target={"_blank"}
                              rel="noreferrer"
                            >
                              <div className="mx-2">
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="20"
                                  height="20"
                                  viewBox="0 0 16.049 15.568"
                                >
                                  <path
                                    id="ic_attachment_24px"
                                    d="M0,3.972A3.97,3.97,0,0,1,3.972,0h7.583a2.889,2.889,0,1,1,0,5.777H5.416a1.805,1.805,0,1,1,0-3.611h5.416V3.611H5.351c-.4,0-.4.722,0,.722h6.2a1.444,1.444,0,1,0,0-2.889H3.972a2.528,2.528,0,1,0,0,5.055h6.861V7.944H3.972A3.97,3.97,0,0,1,0,3.972Z"
                                    transform="translate(0 9.664) rotate(-42)"
                                    fill="#12aac4"
                                  />
                                </svg>
                              </div>

                              <div>
                                {/* filename here */}
                                <p className="m-0 text-dark">
                                  {attachment.attachment}
                                </p>
                              </div>
                            </a>
                          </div>

                          <div className="d-flex col-2 align-items-center justify-content-end">
                            <a
                              download={true}
                              href={`${
                                attachment.type == "Task"
                                  ? paths.TasksAttachments
                                  : paths.ProjectsAttachments
                              }${attachment.id}/${attachment.attachmentId}/${
                                attachment.attachment
                              }`}
                              className={`${styleEnd("m", 4)}`}
                              rel="noreferrer"
                              target={"_blank"}
                            >
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="14"
                                height="16"
                                viewBox="0 0 14 17"
                              >
                                <path
                                  id="ic_file_download_24px"
                                  d="M19,9H15V3H9V9H5l7,7ZM5,18v2H19V18Z"
                                  transform="translate(-5 -3)"
                                  fill="#12aac4"
                                />
                              </svg>
                            </a>
                          </div>
                        </div>
                        {attachment.name ? (
                          <Link
                            to={`${
                              attachment.type == "Task"
                                ? "/taskDetails/"
                                : "/projectDetails/"
                            }${attachment.id}`}
                            className="text-decoration-none hoverLinks p-3 d-flex align-items-center"
                            style={{
                              backgroundColor: "rgb(242, 242, 242)",
                              borderRadius: "10px 10px 0 0",
                            }}
                          >
                            <div
                              style={{
                                height: 32,
                                width: 32,
                                borderRadius: "50%",
                              }}
                              className="d-flex justify-content-center text-center align-items-center px-1"
                            >
                              <div
                                style={{
                                  width: 24,
                                  height: 24,
                                  background: img,
                                  opacity: 1,
                                  backgroundPosition: "center",
                                  backgroundSize: "contain",
                                }}
                              ></div>
                            </div>
                            <div className="px-2">{attachment.name}</div>
                          </Link>
                        ) : null}
                      </div>
                    );
                  })}
                </div>
              );
            })}
          </div>
        </div>
        {files?.data?.length > 0 ? (
          <div className=" mt-5 mb-4">
            <Paginate
              pageCount={Math.ceil(files?.count / 20)}
              currentPage={currentPage}
              clearData={undefined}
              setCurrentPage={setCurrentPage}
              setCurrentPageandResetData={setCurrentPageandResetData}
            />
          </div>
        ) : (
          <div className="d-flex col-9 justify-content-center fa-2x mt-5">
            لا يوجد ملفات
          </div>
        )}
      </>
    );
  return <LoadingPopup show={true} />;
};

export default Files;
